export const inboxConstants = {
    INBOX_HISTORY_FETCH: 'INBOX_HISTORY_FETCH',
    INBOX_HISTORY_SUCCESS: 'INBOX_HISTORY_SUCCESS',
    INBOX_HISTORY_UPDATE: 'INBOX_HISTORY_UPDATE',
    INBOX_HISTORY_ERROR: 'INBOX_HISTORY_ERROR',
    INBOX_RESET: 'INBOX_RESET',
};

export const MessageStatus = {
    Sent: 0,
    Delivered: 1,
    Failed: 2,
    Read: 3,
    Deleted: 4,
};

export const MessageContentType = {
    Text: 0,
    Image: 1,
    File: 2,
    Video: 3,
    Audio: 4,
    StoryVideo: 5,
    StoryImage: 6,
};

export const MessageType = {
    Incoming: 0,
    Outgoing: 1,
};

export const InboxHistory = {
    Message: 0,
    ConversationEvent: 1,
};

export const SenderType = {
    User: 0,
    Bot: 1,
};

export const AssignmentType = {
    User: 0,
    Agent: 1,
    Unassigned: 2,
};
